import { IResourceComponentsProps } from "@refinedev/core";
import { MuiListInferencer } from "@refinedev/inferencer/mui";

export const CategoryList: React.FC<IResourceComponentsProps> = () => {
    return <MuiListInferencer />;
};
